import React from 'react';
import { Tooltip, Text, TextProps } from '@chakra-ui/react';
import { formatRelativeTime } from '../utils/time';

export type RelativeTimeTextProps = {
  date: Date | string | number;
  textProps?: TextProps;
};

export default function RelativeTimeText({ date, textProps }: RelativeTimeTextProps) {
  const { display, exact } = formatRelativeTime(date);
  return (
    <Tooltip label={exact} openDelay={300} hasArrow>
      <Text as="span" {...textProps}>{display}</Text>
    </Tooltip>
  );
}
